// extracted by mini-css-extract-plugin
export default {"content":"Loader_content__bugDV","text":"Loader_text__OxZmr"};